import { TrendingUp } from '@mui/icons-material'
import { PowerData } from '../../types/charts'
import { DashboardViewProps, PowerGraphWidgetConfig, Widget } from './Widget'
import { Box } from '@mui/material'
import { Link } from 'react-router-dom'
import { PowerChart } from '../../components/charts/PowerChart'

export class PowerGraphWidget extends Widget<{ consumption?: PowerData[], production?: PowerData[] }, PowerGraphWidgetConfig> {

  get Icon() {
    return TrendingUp
  }

  get width(): number {
    return 4
  }

  get height(): number {
    return 8
  }

  // get textColor(): string {
  //   return 'white'
  // }

  // get bgColor(): string {
  //   return 'transparent'
  // }

  solarControls() {
    return this.findControslByFilter(ctrl => ctrl.port.type === 'SOLAR')
  }

  powerControls() {
    return this.findControslByFilter(ctrl => ctrl.port.type !== 'SOLAR')
  }

  dashboardTitle(firstOfKind: boolean): string | undefined {
    if (this.name) return this.name

    const hasSolar = this.solarControls().length > 0
    const hasPower = this.powerControls().length > 0

    if (hasSolar && hasPower) return this.app.t('Consumption & Production')
    if (hasSolar) return this.app.t('Production')
    if (hasPower) return this.app.t('Consumption')

    return undefined
  }

  dataUrls(): Record<string, string> {
    const [from, to] = this.dateRange()
    const ret: Record<string, string> = {
    }

    const powers = this.powerControls()
    // TODO: We support currently only one power and one solar.
    if (powers.length > 0) {
      ret.consumption = `/history/power/${powers[0].port.id}?from=${from}&to=${to}&steps=minute`
    }

    const solars = this.solarControls()
    if (solars.length > 0) {
      ret.production = `/history/power/${solars[0].port.id}?from=${from}&to=${to}&steps=minute`
    }

    return ret
  }

  draw(props: DashboardViewProps): React.ReactElement {
    if (!this.data) return <></>

    const [from, to] = this.dateRange()
    const powers = this.powerControls()
    const solars = this.solarControls()

    return (
      <Box sx={{ width: '100%' }}>
        <Link to={`/history#port${powers[0]?.port.id || solars[0]?.port.id}`}>
          <PowerChart
            id={`power${this.id || ''}`}
            data={this.data.consumption || []}
            solar={this.data.production}
            options={{
              from,
              to,
              steps: 'hour',
              smoothening: 'mean',
              key: 'power',
              includeEmpty: true,
              timestamps: false,
              compact: true,
              sparse: true
            }}
          />
        </Link>
      </Box>
    )
  }
}
